export const FETCH_TEAMS = "fetchTeams";
export const CREATE_TEAM = "createTeam";
export const DELETE_TEAM = "deleteTeam";
export const UPDATE_TEAM = "updateTeam";
export const RESET_TEAMS = "resetTeams";
